import { render, staticRenderFns } from "./BdssfReportGeneral.vue?vue&type=template&id=cb49d682&scoped=true&"
import script from "./BdssfReportGeneral.vue?vue&type=script&lang=js&"
export * from "./BdssfReportGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb49d682",
  null
  
)

export default component.exports